import WRAP from "WRAP-JS";
import * as FPEUtils from "../../../utils/FPEUtils";
import { AIRWAY_LEVEL_BOTH, AIRWAY_LEVEL_HIGH, AIRWAY_LEVEL_LOW } from "../../../components/map/layers/Airway";

/* eslint-disable */
WRAP.Renderer.AirwayLabel = function() {
  WRAP.Renderer.GeoJSONExt.call(this);

  const features = [];
  function addFeature(layer, feature, geo, data) {
    feature.geo = geo;
    feature.data = data;
    layer.addFeature(feature);
  }

  const makeArrowSymbol = (w, h, lr) => {
    const vp = 1;
    const hp = 5;
    const ah = h * 0.8;
    const aw = h * 2;
    let r, arrow;

    switch(lr) {
      case "l":
        r = 1;
        arrow = true;
        break;
      case "r":
        r = -1;
        arrow = true;
        break;
      default:
        r = 1;
        arrow = false;
        break;
    }

    const array = [
      [(-w / 2 - hp) * r, -h / 2 - vp], [(w / 2 + hp) * r, -h / 2 - vp],
      [(w / 2 + hp) * r, h / 2 + vp], [(-w / 2 - hp) * r, h / 2 + vp],
    ];
    if (arrow) {
      array.push(
        [(-w / 2 - hp) * r, aw / 2], [(-w / 2 - hp - ah) * r, 0], [(-w / 2 - hp) * r, -aw / 2]
      );
    }
    array.push(array.slice(0, 1)[0]);
    return array;
  }

  const getBoundingRect = (w, h, rotation) => {
    const array = makeArrowSymbol(w, h, "");
    const rad = FPEUtils.deg2rad(rotation);
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);
    let minX, minY, maxX, maxY;
    array.forEach(v => {
      const x = v[0] * cos - v[1] * sin;
      const y = v[0] * sin + v[1] * cos;
      if (minX === undefined || minX > x) {
        minX = x;
      }
      if (maxX === undefined || maxX < x) {
        maxX = x;
      }
      if (minY === undefined || minY > y) {
        minY = y;
      }
      if (maxY === undefined || maxY < y) {
        maxY = y;
      }
    });
    return ([
      minX,
      minY,
      maxX - minX,
      maxY - minY
    ]);
  }

  const superDraw = this.draw;
  let buffer;
  let mask;
  let level;
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    buffer = {};
    level = conf.Attributes.level && conf.Attributes.level() || AIRWAY_LEVEL_BOTH;
    superDraw.apply(this, arguments);
    if (this.drawFlg) {
      features.splice(0);
      features.push.apply(features, Object.values(buffer));
    }
    mask = new WRAP.Geo.Mask(WRAP.Geo.currentView());
    mask.clear();
    layer.clear();
    features.forEach(val => {
      this._drawFeatureImpl(layer, val[0], val[1], val[2]);
    });
    WRAP.Geo.invalidate();
  }

  this.drawFeature = function(layer, item, prop, ts) {
    if ( prop.preferred_route_type ) {
      return;
    }
    buffer[prop.gid] = buffer[prop.gid] || [
      item,
      prop,
      ts
    ];
  }

  this._drawFeatureImpl = function(layer, item, prop, ts) {
    const geo = item;
    const style = ts;
    const text = prop.name;
    const s = Object.assign({
      font_size: 10,
      fill_color: "#000",
      label_color: "#fff",
    }, style);
    if (text !== undefined) {
      const textSize = WRAP.Geo.getTextMetricsAccurate(text, s.font_size);
      const fixes = item.properties.fixes;
      for (let i = 0; i < fixes.length; i++) {
        if (i === fixes.length - 1) continue;

        const targetLevel = (function() {
          switch(level) {
            case AIRWAY_LEVEL_BOTH:
              return ['B', 'H', 'L'];
            case AIRWAY_LEVEL_HIGH:
              return ['B', 'H'];
            case AIRWAY_LEVEL_LOW:
              return ['B', 'L'];
            default:
              return ['B'];
          }
        })();

        if (!targetLevel.includes(prop.level.charAt(i))) continue;

        const p1 = fixes[i];
        const p2 = fixes[i + 1];
        const p1xy = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(p1[1], p1[0]));
        const p2xy = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(p2[1], p2[0]));

        if (Math.pow(p1xy.x - p2xy.x, 2) + Math.pow(p1xy.y - p2xy.y, 2) < Math.pow(textSize[0] + textSize[1] * 2, 2)) {
          continue;
        }

        const gc = new WRAP.Geo.GreatCircle(p1[1], p1[0], p2[1], p2[0]);

        let flg = false;
        let point;
        let rotation;
        let correctedRotation;
        const candidates = (function() {
          if (Math.pow(p1xy.x - p2xy.x, 2) + Math.pow(p1xy.y - p2xy.y, 2) > Math.pow((textSize[0] + textSize[1] * 2) * 4, 2)) {
            return [0.5, 0.25, 0.75];
          }
          return [0.5];
        })();
        for (let i = 0; i < candidates.length; i++) {
          const t = candidates[i];
          const pt = gc.getPosition(t);
          point = [pt.lon, pt.lat];
          const pt1 = gc.getPosition(t - 0.1);
          const pt2 = gc.getPosition(t + 0.1);
          const xy1 = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(pt1.lat, pt1.lon));
          const xy2 = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(pt2.lat, pt2.lon));
          const xy  = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(pt.lat, pt.lon));
          const angle1 = Math.atan2(xy1.y - xy.y, xy1.x - xy.x);
          const angle2 = Math.atan2(xy.y - xy2.y, xy.x - xy2.x);
          const rotationRad = Math.atan2(
            Math.sin(angle1) + Math.sin(angle2),
            Math.cos(angle1) + Math.cos(angle2)
          );
          let correctedRotationRad = rotationRad;
          if (Math.cos(correctedRotationRad) < 0) {
            correctedRotationRad += Math.PI;
          }
          rotation = FPEUtils.rad2deg(rotationRad);
          correctedRotation = FPEUtils.rad2deg(correctedRotationRad);
          const rect = getBoundingRect(textSize[0], textSize[1], rotation);
          if (!mask.intersectRect(point, rect[0], rect[1], rect[2], rect[3])) {
            flg = true;
            mask.addRect(point, rect[0], rect[1], rect[2], rect[3]);
            break;
          }
        }
        if (!flg) continue;

        //矢印
        const dir = dir => {
          switch(dir) {
            case 'F':
              return 'l';
            case 'B':
              return 'r';
            default:
              return '';
          }
        }
        const featureArrow = new WRAP.Geo.Feature.Line({
          point: point,
          line: makeArrowSymbol(textSize[0], textSize[1] + 4, dir(item.properties.direction.charAt(i))),
          strokeStyle: false,
          fillStyle: s.fill_color,
          rotation: rotation,
        })
        addFeature(layer, featureArrow, geo, undefined);

        //ラベル
        const featureLabel = new WRAP.Geo.Feature.Text({
          point: point,
          offsetX: 0,
          offsetY: textSize[1] / 2,
          text: text,
          fontSize: s.font_size,
          fillStyle: s.label_color,
          strokeStyle: false,
          align: 'center',
          rotation: correctedRotation,
        });
        addFeature(layer, featureLabel, geo, undefined);
      }
    }
  }
};
/* eslint-enable */